import { atom } from "jotai";

import type { Props } from "scmp-app/components/advertisement/ad-slots/ad-slot";

type HeaderAdSlotSpec = {
  sizes?: googletag.GeneralSize;
} & Pick<Props, "adUnit" | "autoRefreshOptions" | "targeting" | "zone">;
export const topBannerAdSlotAtom = atom<AdSlotState>(null);
export type AdSlotState = {
  desktop: HeaderAdSlotSpec | null;
  mobile: HeaderAdSlotSpec | null;
} | null;
